import { send } from 'server';

export const fetchDepositLimits = ({ casinoName }) => send({
    ID: 35604,
    description: 'Get Deposit Limits',
    responses: [35605, 35606],
    casinoName
});

export const fetchLimitInfo = () => send({
    ID: 31037,
    description: 'Player limit info',
    responses: [31038, 31039]
});

export const fetchForcedDepositLimitInfo = () => send({
    ID: 35936,
    description: 'Player forced deposit limit info',
    responses: [35937, 35938]
});

export const fetchForcedLimitInfo = () => send({
    ID: 35856,
    description: 'Player forced limit info',
    returnRelatedEntries: true,
    responses: [35857, 35858]
});

export const fetchUpdateDepositLimits = (limits) => send({
    ID: 89904,
    description: 'Set Player Deposit Limits',
    responses: [89908, 89900],
    limits
});

export const fetchGetTimeout = () => send({
    ID: 89909,
    description: 'Get time out request',
    count: 3,
    networkClass: 1,
    responses: [31038, 31039]
});

export const fetchSetTimeout = (period) => send({
    ID: 89910,
    networkClass: 1,
    description: 'Set time out request',
    period,
    emailNotificationType: ['START'],
    responses: [89912, 89900]
});

export const fetchGetRgConfiguration = () => send({
    ID: 32942,
    description: 'GetRgConfigurationRequest',
    type: [1],
    responses: [32943, 32944]
});

export const fetchGetRgTimeouts = () => send({
    ID: 32942,
    description: 'GetRgTimeoutsRequest',
    type: [0],
    responses: [32943, 32944]
});

export const fetchGetPlayerReality = () => send({
    ID: 89913,
    description: 'Get Player Reality Check',
    responses: [89914]
});

export const fetchSetRealityCheck = (timePeriod) => send({
    timePeriod,
    ID: 89915,
    description: 'Set Player Reality Check',
    isEnabled: Boolean(timePeriod),
    correlationId: 'set-reality-check',
    responses: [89916, 89406, 89900]
});

export const fetchPlayerSelfExclusion = () => send({
    ID: 35601,
    responses: [35602, 35603],
    description: 'Get Player Self Exclusion'
});

export const fetchUpdateSelfExclusionPeriod = (period) => send({
    ID: 35631,
    responses: [35632, 35633],
    description: 'Self Exclusion',
    endType: 'manual',
    networkClass: 1,
    period,
    product: 'all'
});
